/**
 * The client-safe half of the verified-payer contract.
 *
 * Separate from `verified-payer.ts` because that module is `server-only` (it
 * reads the database). The client still needs the error code and the snapshot
 * shape so a checkout can react to a gate by opening its verification view
 * rather than showing a dead-end toast.
 */

/** Typed failure returned by every payment-preparing server action. */
export const PHONE_VERIFICATION_REQUIRED = "PHONE_VERIFICATION_REQUIRED";

/** Payer facts resolved by the server. `null` means absent, never a placeholder. */
export type VerifiedPayerSnapshot = {
  userId: string;
  name: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
};

export function isPhoneVerificationRequiredCode(
  code: string | undefined,
): boolean {
  return code === PHONE_VERIFICATION_REQUIRED;
}
